<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      visible
      direction="rtl"
      :size="1000"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules"
          size="mini"
          label-position="top"
        >
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_sample_style_no') || '产品款号'"
                prop="masterSampleStyleNo"
              >
                <el-input
                  v-model="formData.masterSampleStyleNo"
                  maxlength="50"
                  clearable
                  show-word-limit
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item
                :label="$l('form_label_sample_name') || '中文名称'"
                prop="masterSampleName"
              >
                <el-input
                  v-model="formData.masterSampleName"
                  maxlength="100"
                  clearable
                  show-word-limit
                />
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item
                :label="$l('form_label_sample_name_en') || '英文名称'"
                prop="masterSampleNameEn"
              >
                <el-input
                  v-model="formData.masterSampleNameEn"
                  maxlength="100"
                  clearable
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_color_name') || '中文颜色'"
                prop="colorName"
              >
                <el-input
                  v-model="formData.colorName"
                  maxlength="50"
                  clearable
                  show-word-limit
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_color_name_en') || '英文颜色'"
                prop="colorNameEn"
              >
                <el-input
                  v-model="formData.colorNameEn"
                  maxlength="50"
                  clearable
                  show-word-limit
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$l('form_label_goods_size') || '产品尺寸'">
                <el-input v-model="formData.goodsSizeSpec" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_category_name') || '产品类别'"
                prop="categoryCode"
              >
                <CategoryCascader
                  :categoryCode.sync="formData.categoryCode"
                  :categoryName.sync="formData.categoryName"
                  :masterCategoryCode.sync="formData.masterCategoryCode"
                  :masterCategoryName.sync="formData.masterCategoryName"
                  :disabled="disabled"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_is_single') || '是否套装'"
                prop="isSingle"
              >
                <el-select
                  v-model="formData.isSingle"
                  style="width: 100%"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                >
                  <el-option
                    v-for="item in isSingleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_unit_price') || '样品单价（CNY）'"
                prop="unitPrice"
              >
                <el-input-number
                  v-model="formData.unitPrice"
                  :disabled="disabled"
                  style="width: 100%; text-align: left"
                  controls-position="right"
                  :precision="2"
                  :min="0"
                  :max="999999999"
                  :step="0.01"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_qty') || '打样数量'"
                prop="qty"
              >
                <el-input-number
                  v-model="formData.qty"
                  :disabled="disabled"
                  style="width: 100%; text-align: left"
                  controls-position="right"
                  :precision="0"
                  :min="0"
                  :max="999999999"
                  :step="1"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_sample_amount') || '样品费用（CNY）'"
                prop="sampleAmount"
              >
                <el-input-number
                  v-model="formData.sampleAmount"
                  :disabled="disabled"
                  ref="oldValue"
                  style="width: 100%; text-align: left"
                  controls-position="right"
                  :precision="2"
                  :min="0"
                  :max="999999999"
                  :step="0.01"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_add_surcharge') || '附加费（CNY）'"
                prop="addSurcharge"
              >
                <el-input-number
                  v-model="formData.addSurcharge"
                  :disabled="disabled"
                  ref="oldValue"
                  style="width: 100%; text-align: left"
                  controls-position="right"
                  :precision="2"
                  :min="0"
                  :max="999999999"
                  :step="0.01"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_sub_amount') || '小计金额（CNY）'"
              >
                <el-input v-model="v_subAmount" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="d-flex justify-content-end mb-2 mt-3">
          <el-button
            type="primary"
            size="small"
            v-if="!disabled"
            @click="save()"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
        </div>
        <div v-if="paramCode">
          <div class="d-flex mb-2" style="align-items: center">
            <div class="title-text">
              {{ $l('title_text_spec_info') || '规格明细' }}
            </div>
            <el-button
              class="ml-2"
              type="primary"
              plain
              size="mini"
              v-if="showAddSpec"
              @click="onOpenAddSpecWindow('')"
              >{{$l('btn_add_spec') || '新增规格'}}</el-button
            >
          </div>
          <SpecTable
            :tableData="specTableData"
            :loading="specLoading"
            @reload="getSpecData"
            @openEditPage="onOpenAddSpecWindow"
          />
        </div>
      </div>
    </el-drawer>
    <AddSpecWindow
      v-if="addSpecWindowOption.visible"
      :visible="addSpecWindowOption.visible"
      :title="addSpecWindowOption.title"
      :proofingCode="addSpecWindowOption.proofingCode"
      :proofingSampleCode="addSpecWindowOption.proofingSampleCode"
      :proofingSampleDetialCode="addSpecWindowOption.proofingSampleDetialCode"
      :disabled="disabled"
      @close="onCloseAddSpecWindow"
      @reload="reload"
    >
    </AddSpecWindow>
  </div>
</template>
<script>
import CategoryCascader from '../category-cascader'
import SpecTable from './spec-table'
import AddSpecWindow from './add-spec-window'
import validate from '@/libs/util.validate'
import { format, add } from '@/libs/util.number.js'
import EditLoading from '@/mixins/edit-loading'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    proofingCode: {
      type: String,
      default: '',
    },
    proofingSampleCode: {
      type: String,
      default: '',
    },
  },
  mixins: [EditLoading],
  components: { CategoryCascader, SpecTable, AddSpecWindow },
  data() {
    return {
      formData: {
        currencyUnit: 'CNY',
      },
      rules: {
        masterSampleName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        masterSampleNameEn: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        colorName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        colorNameEn: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        unitPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        qty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        sampleAmount: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        addSurcharge: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        categoryCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        isSingle: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      },
      saveReturnCode: '',
      isSingleOptions: [
        {
          label: this.$l('INDEX.YES') || '是',
          value: 'N',
        },
        {
          label: this.$l('INDEX.NO') || '否',
          value: 'Y',
        },
      ],
      specLoading: false,
      specTableData: [],
      addSpecWindowOption: {
        visible: false,
        title: '新增打样产品',
        proofingCode: '',
        proofingSampleCode: '',
        proofingSampleDetialCode: '',
      },
    }
  },
  computed: {
    paramCode() {
      return !this.proofingSampleCode
        ? this.saveReturnCode
        : this.proofingSampleCode
    },
    v_subAmount() {
      return format(add(this.formData.sampleAmount, this.formData.addSurcharge))
    },
    showAddSpec() {
      if (this.formData.isSingle === 'Y') {
        return this.paramCode && this.specTableData.length < 1
      } else {
        return this.paramCode
      }
    },
  },
  async mounted() {
    await this.getData()
    await this.getSpecData()
  },
  methods: {
    async reload() {
      await this.getData()
      await this.getSpecData()
      this.$emit('reload')
    },
    async getData() {
      if (this.paramCode) {
        const res = await this.$api
          .customerProofingSampleDetailApi({
            proofingSampleCode: this.paramCode,
          })
          .catch(() => {})
        this.formData = { ...res.body }
      }
    },
    async getSpecData() {
      if (this.paramCode) {
        this.specLoading = true
        const res = await this.$api
          .customerProofingSampleDetailListApi({
            proofingSampleCode: this.paramCode,
          })
          .catch(() => null)
        this.specLoading = false
        this.specTableData = res?.body?.data || []
      }
    },
    onOpenAddSpecWindow(proofingSampleDetialCode) {
      this.addSpecWindowOption.visible = true
      this.addSpecWindowOption.proofingCode = this.proofingCode
      this.addSpecWindowOption.proofingSampleCode = this.paramCode
      this.addSpecWindowOption.proofingSampleDetialCode =
        proofingSampleDetialCode
      this.addSpecWindowOption.title =
        this.$l('dialog_title_add_spec_info') || '新增规格信息'
    },
    onCloseAddSpecWindow() {
      this.addSpecWindowOption.visible = false
      this.addSpecWindowOption.proofingCode = ''
      this.addSpecWindowOption.proofingSampleCode = ''
      this.addSpecWindowOption.proofingSampleDetialCode = ''
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .customerProofingSampleSaveApi({
          proofingCode: this.proofingCode,
          proofingSampleCode: this.paramCode,
          ...this.formData,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.saveReturnCode = res.body
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getData()
      this.$emit('reload')
    },
    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    handleClose(done) {
      if (this.disabled) {
        this.close()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0 20px 12px;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}

.title-text {
  height: 23px;
  line-height: 23px;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}
</style>
